'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const DatadogInit = () => {
  useEffect(() => {
    if (globalThis.window === undefined) {
      return;
    }

    if (datadogRum.getInitConfiguration()) {
      return;
    }

    if (process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID && process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN) {
      datadogRum.init({
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME || 'installer',
        sessionSampleRate: Number(process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE ?? '100'),
        sessionReplaySampleRate: Number(process.env.NEXT_PUBLIC_DATADOG_REPLAY_SAMPLE_RATE ?? '100'),
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
      });

      datadogRum.startSessionReplayRecording();
    }
  }, []);

  return null;
};
